<template>
  <div class="flexContainer yCenterContainer">
    <img v-if="image" :src="image" class="mediaFileLabel flexContainer centerContainer"/>
    <label v-else for="file" class="mediaFileLabel flexContainer centerContainer">
      <p class="mediaFileLabelContent">+</p>
    </label>
    <input
      @change="handleImageUpload"
      type="file"
      id="file"
      accept="image/jpeg, image/gif"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      image: null,
    };
  },
  methods: {
    handleImageUpload(event) {
      const selectedImage = event.target.files[0];
      this.createBase64Image(selectedImage);
    },
    createBase64Image(fileObject) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
        this.sendNewInputToParent(e.target.result);
      };
      reader.readAsDataURL(fileObject);
    },
    sendNewInputToParent(data) {
      this.$emit("form_update_notification", data);
    },
  },
};
</script>

<style scoped>
[type="file"] {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  white-space: nowrap;
  width: 1px;
}

.mediaFileLabel {
  margin-left: 1%;
  height: 90%;
  width: 30%;
  border: 1px solid #958efb;
}

img,
label {
  margin-left: 1%;
  height: 90%;
  width: 23%;
}

p {
  font-size: 62px;
  font-weight: lighter;
  cursor: pointer;
}
</style>
